import type { ServiceOption } from './schemas/quote'

/**
 * Value sent on the GA4 `generate_lead` event so Google Ads can bid toward the
 * work worth having. Every lead used to report the driveway special price flat,
 * which handed Smart Bidding a constant and nothing to optimise against.
 *
 * Everything is a multiple of the driveway price so the whole scale tracks
 * whatever Paul sets in the admin, and so the ratios stay the thing being
 * asserted. Two of them are Gordon's explicit calls: a rock wall is worth
 * double a driveway, and a quote form is worth double a phone call. The rest
 * are estimates and are the first numbers to revisit if bidding drifts toward
 * the wrong work.
 */

const SERVICE_MULTIPLIER: Record<ServiceOption, number> = {
  'rock-walls': 2, // Gordon: always worth double a driveway
  driveway: 1, // the base everything else is priced against
  retaining: 1.5,
  'subdivision-civil': 2.5,
  'council-infrastructure': 2.5,
  'ongoing-partnership': 2.5,
  'site-prep': 1.5,
  'grant-ready': 1.5,
  excavation: 1.25,
  'emergency-storm': 1.25,
  steps: 1,
  landscaping: 1,
  paths: 0.75,
  drainage: 0, // Paul doesn't want drainage jobs, so it is worth nothing to bid for
  other: 1,
  notsure: 1,
}

// Gordon: a quote form is worth double a phone call. A tap tells us nothing
// about the job, so it sits at half the base rather than half of a service.
const PHONE_CALL_MULTIPLIER = 0.5

export function leadValue(service: ServiceOption, drivewayPrice: number): number {
  return Math.round(drivewayPrice * SERVICE_MULTIPLIER[service])
}

export function phoneLeadValue(drivewayPrice: number): number {
  return Math.round(drivewayPrice * PHONE_CALL_MULTIPLIER)
}
